import SourceModel             from 'Models/invoice/SourceModel';
import ContractIterationModel  from 'Models/sales/ContractIterationModel';
import QuotationModel          from 'Models/sales/QuotationModel';
import doc                     from 'decorators/doc';
import model                   from 'decorators/model';
import { Timestampable }       from 'helpers/traits';
import SupplierPrivateApiModel from 'modelx/models/abstracts/SupplierPrivateApiModel';

const customDoc = doc;

@model.staticLabel('OrderGroupHolder')
@model.urnResource('order_group_holder')
@doc.path('/order_group_holders/{?id}')
export default class OrderGroupHolderModel extends Timestampable(SupplierPrivateApiModel) {
	public _filters: ModelFiltersExtended<{
		'holderUrn': Urn;
	}> = {};

	public _sorts: ModelSortsExtended<{
		'id': string;
		'label': string;
	}> = {};

	@doc.string declare label: string;
	@customDoc.modelUrn(SourceModel) declare holder: QuotationModel | ContractIterationModel | SourceModel;
}